@if (!showIcon()) {
  <button mat-button (click)="open()">{{ displayName() }}</button>
}
@if (showIcon()) {
  <button mat-icon-button (click)="open()">
    <app-icon [icon]="icon()"></app-icon>
  </button>
}